import type { PrototypeMetadata } from "@faire/prototype-playground/workspace/types";

export const prototypeMeta: PrototypeMetadata = {
  name: "SPE AI inline (mock)",
  owner: "Yikai Zhou",
  email: "zhou.yikai76@gmail.com",
  status: "in-progress",
  createdAt: "2026-05-19",
  lastUpdated: "2026-05-19",
  surfaceArea: "Brand",
  category: "experimental",
  creationTool: "cursor",
  thumbnail: "/images/thumbnails/yz-spe-ai-inline-spe-mock.png",
  description:
    "Full single-product editor (no wizard): images first, then mock AI title/description and product options with sparkle tooltips matching the wizard branch.",
};
